<template>

  <div id="loginbg">  ·
    <div id="ding">
      <div class="title"id="wenzi">
        自提系统
      </div>
      <div class="title"id="zhanghao">
        账号
      </div>
      <div class="title"id="tuichu"@click="logout">
        【退出】
      </div>
      <div class="title"id="yuyue"@click="tiaozhuanyuyue">
        预约
      </div>
    </div>
    <el-table :data="pageData.rows" v-loading="listLoading"size=mini
              style="width: 97%; left: 25px;height:580px;top: 40px; ">
      <el-table-column prop="id" label="id"  width="40" v-if="false">
      </el-table-column>
      <el-table-column prop="card" label="提货卡号"  width="80">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="80" sortable>
      </el-table-column>
      <el-table-column prop="phone" label="电话" width="100" sortable>
      </el-table-column>
      <el-table-column prop="address" label="地址" width="190" sortable>
      </el-table-column>
      <el-table-column prop="detailAddress" label="详细地址" width="190" sortable>
      </el-table-column>
      <el-table-column prop="orderProduct" label="商品名称" width="120" sortable>
      </el-table-column>
      <el-table-column prop="spec" label="规格" width="140" sortable>
      </el-table-column>
      <el-table-column prop="numberProduct" label="数量" width="80" sortable>
      </el-table-column>
      <el-table-column prop="appointmentTime" label="预约时间" width="140" sortable>
      </el-table-column>
      <el-table-column prop="logisticsNumber" label="物流单号" width="140" sortable>
      </el-table-column>
      <el-table-column prop="province" label="省" width="140" v-if="false"sortable>
      </el-table-column>
      <el-table-column prop="city" label="市" width="140"v-if="false" sortable>
      </el-table-column>
      <el-table-column prop="area" label="区" width="140"v-if="false" sortable>
      </el-table-column>
      <el-table-column prop="state" label="状态" width="80" sortable>
        <template slot-scope="scope">
          <!-- 这里因为要通过1或0的属性值 取值显示不同颜色,且在js中只能原文输出,所以在这里进行  vue的if判断 -->
          <span v-if="scope.row.state == -1" style="color: red">已取消</span>
          <span v-if="scope.row.state == 0" style="color: dodgerblue">已预约</span>
          <span v-if="scope.row.state == 1" style="color: dodgerblue">已受理</span>
          <span v-if="scope.row.state == 2" style="color: green">已发货</span>
        </template>
      </el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              width="150"
              >
        <template slot-scope="scope">
          <span v-if="scope.row.state == 2">
            <el-button  @click="handleSelect1(scope.$index, scope.row)" type="primary" size="mini">查看</el-button>
          </span>
          <span v-if="scope.row.state == 0">
             <el-button type="primary" size="mini"@click="handleEdit(scope.$index, scope.row)">修改</el-button>
          <el-button type="danger" size="mini"@click="handleDelete(scope.$index, scope.row)">取消</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
      <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :current-page="query.page"
              :page-size="10"
              :total="pageData.total"
              style="position: absolute;margin-left: 550px;margin-top: -10px;">
      </el-pagination>


    <el-dialog  :visible.sync="selectVisible" style="left: 250px;width: 1000px">
      <el-form :model="selectdata" label-width="80px">
        <img src="../../assets/组 689.png"style="position: absolute;left: 50px;top: 20px;">
        <el-form-item prop="deliverTime"style="height: 5px;margin-top:-50px;margin-left: -25px;width: 380px">
          <el-row style="color: #bbbbbb">{{selectdata.deliverTime}}</el-row>
        </el-form-item>
        <el-link style="left: 360px;top: -18px;color: firebrick;font-size: 10px"  @click="selectLogisticsDetail()">详情信息</el-link>
        <el-form-item prop="detailAddress"style="margin-left: -25px;width: 380px;margin-top: -20px;">
          <el-row style="font-size: 10px;color: #bbbbbb">{{selectdata.detailAddress}}</el-row>
        </el-form-item>
        <el-form-item prop="logisticsDate"style="height: 10px;margin-left: -25px;">
          <el-row style="color: firebrick">{{selectdata.logisticsDate}}</el-row>
        </el-form-item>
        <el-form-item prop="logisticsAddress" style="margin-left: -25px;height: 100px;">
          <el-row style="font-size: 10px;line-height:20px;">{{selectdata.logisticsAddress}}</el-row>
        </el-form-item>
        <el-form-item prop="number" style="margin-left: -25px;height: 5px;">
          <el-row style="font-size: 12px;line-height:10px;font-weight: 700">物流单号：{{selectdata.number}}</el-row>
        </el-form-item>
        <el-form-item prop="userName" style="margin-left: -25px;height: 5px;">
          <el-row style="font-size: 12px;line-height:10px;font-weight: 700">收件人姓名：{{selectdata.userName}}</el-row>
        </el-form-item>
        <el-form-item prop="phone" style="margin-left: -25px;height: 5px;">
          <el-row style="font-size: 12px;line-height:10px;font-weight: 700">收件人电话：{{selectdata.phone}}</el-row>
        </el-form-item>
        <el-form-item prop="card" style="margin-left: -25px;height: 5px;">
          <el-row style="font-size: 12px;line-height:10px;font-weight: 700">提货卡号：{{selectdata.card}}</el-row>
        </el-form-item>
        <el-form-item prop="address" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">地址：{{selectdata.address}}</el-row>
      </el-form-item>
        <el-form-item prop="userDetailAddress" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">详细地址：{{selectdata.userDetailAddress}}</el-row>
      </el-form-item>
        <el-form-item prop="orderProduct" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">商品名称：{{selectdata.orderProduct}}</el-row>
      </el-form-item>
        <el-form-item prop="spec" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">商品规格：{{selectdata.spec}}</el-row>
      </el-form-item>
        <el-form-item prop="numberProduct" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">商品数量：{{selectdata.numberProduct}}</el-row>
      </el-form-item>
        <el-form-item prop="deliverTime" style="margin-left: -25px;height: 5px;">
        <el-row style="font-size: 12px;line-height:10px;font-weight: 700">发货时间：{{selectdata.deliverTime}}</el-row>
      </el-form-item>
      </el-form>
    </el-dialog>
      <el-dialog :visible.sync="selectLogisticsVisible"style="left: 250px;width: 1000px;">
        <el-form label-width="80px" style="height: 470px;overflow-y: auto;" >
          <img src="../../assets/zhu.jpg" style="position: absolute;left: 40px;height: 450px;">
          <el-form-item  style="margin-left: -25px;margin-top: 5px;">
            <el-row style="font-size: 14px;line-height:1px;color: firebrick" v-if="selectLogisticsData[0]">{{selectLogisticsData[0].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 50px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;color: firebrick"v-if="selectLogisticsData[0]">{{selectLogisticsData[0].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 5px;"v-if="selectLogisticsData[1]">{{selectLogisticsData[1].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -5px;">
            <el-row style="font-size: 8px;line-height:20px;"v-if="selectLogisticsData[1]">{{selectLogisticsData[1].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: 70px;">
            <el-row style="font-size: 14px;line-height:10px;"v-if="selectLogisticsData[2]">{{selectLogisticsData[2].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: 10px;">
            <el-row style="font-size: 8px;line-height:20px;margin-top: -10px;"v-if="selectLogisticsData[2]">{{selectLogisticsData[2].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 45px"v-if="selectLogisticsData[3]">{{selectLogisticsData[3].time}}</el-row>
          </el-form-item>
          <el-form-item style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 8px;line-height:20px;top: 35px"v-if="selectLogisticsData[3]">{{selectLogisticsData[3].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 60px"v-if="selectLogisticsData[4]">{{selectLogisticsData[4].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 60px"v-if="selectLogisticsData[4]">{{selectLogisticsData[4].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 80px"v-if="selectLogisticsData[5]">{{selectLogisticsData[5].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 80px"v-if="selectLogisticsData[5]">{{selectLogisticsData[5].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 110px"v-if="selectLogisticsData[6]">{{selectLogisticsData[6].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 110px"v-if="selectLogisticsData[6]">{{selectLogisticsData[6].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 140px"v-if="selectLogisticsData[7]">{{selectLogisticsData[7].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 140px"v-if="selectLogisticsData[7]">{{selectLogisticsData[7].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 170px"v-if="selectLogisticsData[8]">{{selectLogisticsData[8].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 170px"v-if="selectLogisticsData[8]">{{selectLogisticsData[8].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 200px"v-if="selectLogisticsData[9]">{{selectLogisticsData[9].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 200px"v-if="selectLogisticsData[9]">{{selectLogisticsData[9].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 230px"v-if="selectLogisticsData[10]">{{selectLogisticsData[10].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 230px"v-if="selectLogisticsData[10]">{{selectLogisticsData[10].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 260px"v-if="selectLogisticsData[11]">{{selectLogisticsData[11].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 260px"v-if="selectLogisticsData[11]">{{selectLogisticsData[11].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 290px"v-if="selectLogisticsData[12]">{{selectLogisticsData[12].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 290px"v-if="selectLogisticsData[12]">{{selectLogisticsData[12].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 320px"v-if="selectLogisticsData[13]">{{selectLogisticsData[13].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 320px"v-if="selectLogisticsData[13]">{{selectLogisticsData[13].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 350px"v-if="selectLogisticsData[14]">{{selectLogisticsData[14].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 350px"v-if="selectLogisticsData[14]">{{selectLogisticsData[14].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 380px"v-if="selectLogisticsData[15]">{{selectLogisticsData[15].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 380px"v-if="selectLogisticsData[15]">{{selectLogisticsData[15].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 410px"v-if="selectLogisticsData[16]">{{selectLogisticsData[16].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 410px"v-if="selectLogisticsData[16]">{{selectLogisticsData[16].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 440px"v-if="selectLogisticsData[17]">{{selectLogisticsData[17].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 440px"v-if="selectLogisticsData[17]">{{selectLogisticsData[17].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 470px"v-if="selectLogisticsData[18]">{{selectLogisticsData[18].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 470px"v-if="selectLogisticsData[18]">{{selectLogisticsData[18].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 500px"v-if="selectLogisticsData[19]">{{selectLogisticsData[19].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 500px"v-if="selectLogisticsData[19]">{{selectLogisticsData[19].status}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;">
            <el-row style="font-size: 14px;line-height:10px;top: 530px"v-if="selectLogisticsData[20]">{{selectLogisticsData[20].time}}</el-row>
          </el-form-item>
          <el-form-item  style="margin-left: -25px;height: 5px;margin-top: -10px;">
            <el-row style="font-size: 8px;line-height:20px;top: 530px"v-if="selectLogisticsData[20]">{{selectLogisticsData[20].status}}</el-row>
          </el-form-item>

        </el-form>
      </el-dialog>

    <el-form :model="resform3"  id="products1" :rules="rules3" label-width="100px" ref="resform3" :close-on-click-modal="false" style="display: none;position: absolute;left: 450px;
    top: 20px;">
      <div id="errorimg">
        <img id="error" src="../../assets/error.png" @click="tuichu()">
      </div>
      <el-form-item label="提货卡卡号:" style="margin-left: 20px" >
        <el-row onfocus="this.blur()" >{{this.resform3.card}}</el-row>
      </el-form-item>
      <el-form-item label="收件人姓名:" prop="name" style="margin-left: 20px" >
        <el-input v-model="resform3.name"></el-input>
      </el-form-item>
      <el-form-item label="收件人电话:" prop="phone" style="margin-left: 20px">
        <el-input v-model="resform3.phone"></el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="code" style="margin-left: 20px">
        <el-input v-model="resform3.code"placeholder="不修改手机号则不用获取验证码"></el-input>
        <el-button id="code" type="primary" size="mini" style="position: absolute;left: 323px;top: 6px;width: 100px" @click="sendCode" :disabled="codeDisabled">{{codeMsg}}</el-button>
      </el-form-item>
      <el-form-item label="地址:" prop="address" style="margin-left: 20px">
        <v-distpicker v-model="resform3.address"
                      @province="provinceChange"
                      :province="resform3.province"
                      @city="cityChange"
                      :city="resform3.city"
                      @area="areaChange"
                      :area="resform3.area"
        >
          </v-distpicker>
      </el-form-item>
      <el-form-item label="详细地址:" prop="detailAddress" style="margin-left: 20px" >
        <el-input v-model="resform3.detailAddress"></el-input>
      </el-form-item>
      <el-form-item label="发货时间:" prop="appointmentTime" style="margin-left: 20px">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
              v-model="resform3.appointmentTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary"  style="width:100%;margin-left: -30px;" @click="reservationUpdate" :loading="resLoading">确定</el-button>
      </el-form-item>
      <div style="background-color: #eaeaea;width: 570px;height: 70px;border-radius:7px;height: 65px;">
        <div style="top: 645px;width: 500px;margin-left: 40px;">
          提示：快递公司收件后正常情况下可以当天发出。一般快递公司正常每天装包发车的时间为下午四点，在装包发车时间之前被快递员收取的快递，当天都可以正常发出。请用户合理安排时间。
        </div>
      </div>

    </el-form>
  </div>
</template>
<script>
  //import NProgress from 'nprogress'
  import VDistpicker from "v-distpicker";

  export default {
    components:{
      VDistpicker//注册组件
    },
    data() {
      return {
        // 是否禁用按钮
        codeDisabled: false,
        // 倒计时秒数
        countdown: 60,
        // 按钮上的文字
        codeMsg: '获取验证码',
        // 定时器
        timer: null,
        province:"",
        city :"",
        area :"",
        listLoading: false,
        selectVisible: false,//查看界面是否显示
        selectLogisticsVisible: false,
        upVisible: false,
        resform3:{
          id: null,
          card:"",
          phone:"",
          name:"",
          address:"",
          detailAddress:"",
          appointmentTime:null,
          code:"",
          province:"",
          city :"",
          area :"",
        },
        selectdata:{
          detailAddress:"",
          logisticsAddress:"",
          logisticsDate:null,
          deliverTime:null,
          userName: "",
          number: "",
          phone: "",
          card: "",
          address: "",
          userDetailAddress: null,
          orderProduct: "",
          spec: "",
          numberProduct: ""
        },
        selectLogisticsData:[
          {
            time:'',
            status:''
          }
        ],
        resLoading:false,
        logining: false,
        checked: false,
        pageData: {
          total: 0,
          rows: []
        },
        query: {
          page: 1,
          phone: ""
        },
        rules3: {
          name: [
            { required: true, message: '请输入收件人姓名', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          phone: [
            { required: true, message: '请输入收件人电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
            //{ validator: validaePass2 }
          ],
          /*code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],*/
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          detailAddress: [
            { required: true, message: '请输入详细地址', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          appointmentTime: [
            { required: true, message: '请选择发货时间', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: '../../assets/LOGO-800.png'
        },
      };
    },
    methods: {
      tuichu(){
        document.getElementById("products1").style.display="none";},
      //显示编辑界面
      handleEdit: function (index, row) {
        document.getElementById("products1").style.display="";
        this.resform3.id = row.id
        this.resform3.card = row.card
        this.resform3.phone = row.phone
        this.resform3.name = row.name
        this.resform3.address = row.address
        this.resform3.detailAddress = row.detailAddress
        this.resform3.appointmentTime = row.appointmentTime
        this.resform3.province = row.province
        this.resform3.city = row.city
        this.resform3.area = row.area
      },
      //显示查询页面
      handleSelect1: function (index, row) {
        this.selectVisible = true;
        this.selectdata = Object.assign({}, row);
        this.handleClick(index, row)
      },
      handleCurrentChange(page) {
        this.query.page = page
        this.getpagelist();
      },
      //获取分页列表
      getpagelist() {
        this.listLoading = true;
        this.query.phone = this.$route.query.phone;
        this.$http.post("/reservationOrder/selectPhone", this.query).then(res => {
          this.pageData = res.data.data
          this.listLoading = false;
        }).catch(error => {
          this.listLoading = false;
          this.$message({ message: "数据加载失败["+error.message+"]", type: 'error' });
        })
      },
      handleClick(index, row){
        let param={
          phone : row.phone,
          number:row.logisticsNumber
        }
        this.$http.post("/reservationOrder/selectLogistics", param).then(res => {
          var datas = res.data.data;
          this.selectDeliverDetail(param,datas);
        }).catch(error => {
          this.$message({ message: "数据加载失败["+error.message+"]", type: 'error' });
        })
      },
      selectDeliverDetail(param,datas){
      let param1={
        number:param.number
      }
      this.$http.post("/reservationOrder/selectDeliverDetail", param1).then(res => {
        this.selectdata = res.data.data;
        this.selectdata.detailAddress = datas.detailAddress
        this.selectdata.logisticsAddress = datas.logisticsAddress
        this.selectdata.logisticsDate = datas.logisticsDate
      }).catch(error => {
        this.$message({ message: "数据加载失败["+error.message+"]", type: 'error' });
      })
    },
      selectLogisticsDetail(){
        this.selectLogisticsVisible= true;
        this.selectVisible= false;
        let param2={
          number:this.selectdata.number,
          phone:this.selectdata.phone
        }
        //console.log(param2)
        this.$http.post("/reservationOrder/selectLogisticsDetail", param2).then(res => {
          if(res.data.success){
            this.selectLogisticsData = res.data.data
            for (var i = 0;i<this.selectLogisticsData.length;i++){
              this.selectLogisticsData.time = this.selectLogisticsData[i].time
            }
            if( this.selectLogisticsData[0].status.length > 80){
              let str = this.selectLogisticsData[0].status;
              let str1 = str.substring(0,80)
              this.selectLogisticsData[0].status =str1+"..."
            }
            if (this.selectLogisticsData[1].status.length > 80){
              let str = this.selectLogisticsData[1].status;
              let str1 = str.substring(0,80)
              this.selectLogisticsData[1].status =str1+"..."
            }
            if (this.selectLogisticsData[2].status.length > 40){
              let str = this.selectLogisticsData[2].status;
              let str1 = str.substring(0,40)
              this.selectLogisticsData[2].status =str1+"..."
            }
            if (this.selectLogisticsData[3].status.length > 40){
              let str = this.selectLogisticsData[3].status;
              let str1 = str.substring(0,40)
              this.selectLogisticsData[3].status =str1+"..."
            }
            if (this.selectLogisticsData[4].status.length > 30){
              let str = this.selectLogisticsData[4].status;
              let str1 = str.substring(0,30)
              this.selectLogisticsData[4].status =str1+"..."
            }
            if (this.selectLogisticsData[5].status.length > 20){
              let str = this.selectLogisticsData[5].status;
              let str1 = str.substring(0,20)
              this.selectLogisticsData[5].status =str1+"..."
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({ message: "数据加载失败["+error.message+"]", type: 'error' });
        })
      },
      //三个选择框的值改变事件，data参数：返回选择框改变时候的值，是一个对象
      provinceChange(event) {//省
        this.province = event.value;
        //this.resform3.address = this.province;
      },
      cityChange(event) {//市
        this.city = event.value;
        /*if (this.resform3.address == this.city) {
          this.resform3.address = this.city;
        } else {
          this.resform3.address += this.city;
        }*/
      },
      areaChange(event) {//区、县
        this.area = event.value;
        //this.resform3.address += this.area;
      },
      sendCode() {
        var loginPhone = {
          phone: this.resform3.phone
        };
        this.$http.post("/code/send", loginPhone).then(result => {
          if (result.data.success) {
            this.$message.success("手机验证码已经发送到您的手机，请在3分钟内使用");
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr();
              this.timer = setInterval(this.getValidStr, 1000)
            }
          } else {
            this.$message.error(result.data.message);
          }
        }).catch(result => {
          this.$message({
            message: "获取失败",
            type: 'error'
          });
        })
      },
      getValidStr(){
        if (this.countdown > 0 && this.countdown <= 60) {
          this.countdown--;
          if (this.countdown !== 0) {
            this.codeMsg = "重新发送" + this.countdown + "S";
            this.codeDisabled = true;
          } else {
            clearInterval(this.timer);
            this.codeMsg = "获取验证码";
            this.countdown = 60;
            this.timer = null;
            this.codeDisabled = false;
          }
        }
      },
      reservationUpdate(){
        this.$refs.resform3.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.resLoading = true;
              if (this.province == this.city || this.city == '县') {
                this.resform3.address = this.province + this.area
              }else if (this.city == this.area){
                this.resform3.address = this.province + this.city
              }else {
                this.resform3.address = this.province + this.city + this.area
              }
              //console.log('输出', this.resform3.address);
              this.resform3.province = this.province;
              this.resform3.city = this.city;
              this.resform3.area = this.area;
              let para = Object.assign({}, this.resform3);
              //console.log(para)
              //console.log(this.resform3)
              //console.log(this.selectdata.card)
              this.$http.post("/reservationOrder/save",para).then(res=>{
                this.resLoading = false;
                if(res.data.success){
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  document.getElementById("products1").style.display="none";
                  this.getpagelist();
                }else{
                  this.$message.error(res.data.message);
                }
              })
            }).catch(error => {
              this.$message({
                message: '修改失败',
                type: 'error'
              });
              this.resLoading = false;
              return;
            });
          }
        });
      },
      handleDelete: function (index, row) {
        this.$confirm('确认取消该预约单吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.$http.get("/reservationOrder/userCancel/" + row.id).then(result => {
            result = result.data;
            if (result.success) {
              this.$message({
                message: result.message,
                type: 'success'
              });
              this.query.page = 1;
              this.getpagelist();
            } else {
              this.$message({
                message: result.message,
                type: 'error'
              });
              this.query.page = 1;
              this.getpagelist();
            }
          }).catch(result => {
            this.$message({
              message: '系统繁忙，稍后重试！！',
              type: 'error'
            });
          })
        }).catch(() => {

        });
      },
      //退出
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          //====================退出的时候需要刷新一下本地的路由缓存
          //location.reload();
          //================
          this.$router.push({ path: '/login' });
        }).catch(() => {
        });
      },
      tiaozhuanyuyue(){
        this.$router.push({ path: '/cardLogin' });
      },
    },
    mounted() {
      this.getpagelist();
    }
  }

</script>

<style lang="scss" scoped>
  #products2{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 7px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #products1{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 30px auto;
    width: 550px;
    padding: 14px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;
    background-repeat: no-repeat;
    height: 100%;
    //background-color: black;
  }
  #ding{
    background-color: #303133;
    height: 58px;
    margin-top: -18px;
  }
  #wenzi{
    position: absolute;
    margin-top: 18px;
    font-size: large;
    color: white;
    left: 100px;
    font-family: "PingFang SC";
    font-weight: 600;
  }
  #zhanghao{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 230px;
    font-family: "PingFang SC";
    font-weight: 400;
  }
  #tuichu{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 400px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #tuichu:hover {
    color: #c1e9f8;
  }
  #yuyue{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 320px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #yuyue:hover {
    color: #c1e9f8;
  }
  #errorimg{
    position: absolute;
    left: 610px;
    top: 15px;
  }
</style>



// WEBPACK FOOTER //
// UserReservationOrder.vue?fb258cea